import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { routes } from "~/constants";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { useMetaByPathConfig } from "~/OnboardingApp/features/Nav/hooks";
import {
  ComputedStepRedirecter,
  OnboardingSourceRedirector,
} from "./components";

interface Props {
  children: ReactNode;
}

export const OnboardingRedirector: FC<Props> = ({ children }) => {
  const currentUser = useCurrentUser();
  const { questionnaireOrder, completedNextPath } = useMetaByPathConfig();
  const location = useLocation();
  const currentRoute = location.pathname;

  if (
    questionnaireOrder.indexOf(currentRoute) === -1 &&
    currentRoute != completedNextPath
  ) {
    return <Navigate to={questionnaireOrder[0]} state={location.state} />;
  }

  if (currentUser?.isOnboarded && !!currentUser?.subscription?.plan) {
    return <Navigate to={routes.dashboard} />;
  }

  return (
    <OnboardingSourceRedirector>
      <ComputedStepRedirecter>{children}</ComputedStepRedirecter>
    </OnboardingSourceRedirector>
  );
};
